import { createI18n } from 'vue-i18n'
import ko from './ko.json'
import en from './en.json'

const LOCALE_KEY = 'app-locale'
const SUPPORTED = ['ko', 'en']

function detectBrowserLocale() {
  const list = (typeof navigator !== 'undefined'
    && (navigator.languages || [navigator.language || navigator.userLanguage])) || []
  for (const raw of list) {
    if (!raw) continue
    const lower = raw.toLowerCase()
    if (lower === 'ko' || lower.startsWith('ko-')) return 'ko'
    if (lower === 'en' || lower.startsWith('en-')) return 'en'
  }
  return null
}

function getStoredLocale() {
  let stored
  try {
    stored = localStorage.getItem(LOCALE_KEY)
  } catch (e) {
    stored = null
  }
  if (SUPPORTED.includes(stored)) return stored
  return detectBrowserLocale() || 'ko'
}

const i18n = createI18n({
  legacy: true,
  locale: getStoredLocale(),
  fallbackLocale: 'en',
  messages: { ko, en }
})

export function setLocale(locale) {
  if (!SUPPORTED.includes(locale)) return
  i18n.global.locale = locale
  try {
    localStorage.setItem(LOCALE_KEY, locale)
  } catch (e) {
    // ignore storage failures (private browsing, quota)
  }
  document.documentElement.lang = locale
}

export { LOCALE_KEY, SUPPORTED, getStoredLocale }
export default i18n
